import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import { OpsPaymentMethodsComponent } from './ops-payment-methods.component';
import { OpsSettingsAddButtonComponent } from '../ops-settings-add-button/ops-settings-add-button.component';
import { SettingsEditState } from '@ops/services';
import { NgxsModule } from '@ngxs/store';
import { OpsCalendarComponent } from '../ops-calendar/ops-calendar.component';
import { OpsInputPreviewComponent } from '../ops-input-preview/ops-input-preview.component';
import { OpsBankAccountCreateComponent } from '../ops-bank-account-create/ops-bank-account-create.component';
import { OpsCreditCardCreateComponent } from '../ops-credit-card-create/ops-credit-card-create.component';
import { OpsCheckboxComponent } from '../ops-checkbox/ops-checkbox.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpsInputComponent,
    OpsInputPreviewComponent,
    OpsCheckboxComponent,
    OpsBankAccountCreateComponent,
    OpsCreditCardCreateComponent,
    OpsSelectComponent,
    OpsSettingsAddButtonComponent,
    OpsCalendarComponent,
    NgxsModule.forRoot([SettingsEditState]),
    TranslateModule,
  ],
  declarations: [OpsPaymentMethodsComponent],
  exports: [OpsPaymentMethodsComponent],
})
export class OpsPaymentMethodsModule {}
